import script from "./QuizFinalDayFallingEffect.vue?vue&type=script&setup=true&lang=ts"
export * from "./QuizFinalDayFallingEffect.vue?vue&type=script&setup=true&lang=ts"

import "./QuizFinalDayFallingEffect.vue?vue&type=style&index=0&id=f739e2f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f739e2f6"]])

export default __exports__